import { TextField, TextFieldProps } from "@mui/material";
import * as React from "react";

/////////////////////////////////////////////////////////////////////////////////////

export const TextFieldFilter: React.FC<TextFieldProps> = ({ ...props }) => {

    return (
        <TextField
            {...props}
            slotProps={{
                ...props.slotProps,
                input: {
                    ...props.slotProps?.input,
                }
            }}
        />
    );
};
